module.exports = __webpack_public_path__ + "img/m8.88f1ce28.jpg";